import { createAction } from '@reduxjs/toolkit';

export const FETCHING_SCHOOL_LIST = 'FETCHING_SCHOOL_LIST';
export const FETCHING_SCHOOL_LIST_SUCCESS = 'FETCHING_SCHOOL_LIST_SUCCESS';
export const FETCHING_SCHOOL_LIST_FAILURE = 'FETCHING_SCHOOL_LIST_FAILURE';
export const CREATE_SCHOOL = 'SCREATE_SCHOOL';
export const GET_SCHOOL_DETAIL = 'GET_SCHOOL_DETAIL';
export const UPDATE_SCHOOL = 'UPDATE_SCHOOL';
export const CLEAR_SCHOOL = 'CLEAR_SCHOOL';
export const FETCH_SCHOOL_MODULES_LIST = 'FETCH_SCHOOL_MODULES_LIST';
export const FETCH_SCHOOL_MODULES = 'FETCH_SCHOOL_MODULES';
export const FETCHING_PROVINCE_LIST = 'FETCHING_PROVINCE_LIST';
export const FETCHING_DISTRICT_LIST = 'FETCHING_DISTRICT_LIST';
export const FETCHING_WARD_LIST = 'FETCHING_WARD_LIST';
export const FETCHING_BANK_SUPPORT_LIST = 'FETCHING_BANK_SUPPORT_LIST';
export const ADD_SCHOOL_MODULE = 'ADD_SCHOOL_MODULE';
export const REMOVE_SCHOOL_MODULE = 'REMOVE_SCHOOL_MODULE';
export const FETCH_PERSONNEL_LIST_REQUEST = 'FETCH_PERSONNEL_LIST_REQUEST';
export const FETCH_PERSONNEL_LIST_SUCCESS = 'FETCH_PERSONNEL_LIST_SUCCESS';
export const FETCH_PERSONNEL_LIST_FAILURE = 'FETCH_PERSONNEL_LIST_FAILURE';
export const FETCH_SCHOOL_YEARS_LIST = 'FETCH_SCHOOL_YEARS_LIST';
export const CREATE_SCHOOL_YEAR = 'CREATE_SCHOOL_YEAR';
export const UPDATE_SCHOOL_YEAR = 'UPDATE_SCHOOL_YEAR';
export const ASSIGN_SCHOOL_YEAR = 'ASSIGN_SCHOOL_YEAR';
export const FETCH_PREVIEW_UPGRADE_CLASS = 'FETCH_PREVIEW_UPGRADE_CLASS';
export const CONFIRM_UPGRADE_CLASS = 'CONFIRM_UPGRADE_CLASS';
export const FETCH_UPGRADE_CLASS_LOGS = 'FETCH_UPGRADE_CLASS_LOGS';
export const DOWNLOAD_TEMPLATE_ACCOUNT_SCHOOL_LIST = 'DOWNLOAD_TEMPLATE_ACCOUNT_SCHOOL_LIST';
export const CREATE_SCHOOL_MODULE_GRADE = 'CREATE_SCHOOL_MODULE_GRADE';
export const DELETE_SCHOOL_MODULE_GRADE = 'DELETE_SCHOOL_MODULE_GRADE';
export const DELETE_SCHOOL = 'DELETE_SCHOOL';

export type DeleteSchoolPayload = {
  /** Primary key in URL `DELETE /api/schools/{pk}/` */
  id: string;
};

export type CreateSchoolModuleGradePayload = {
  school_id: number;
  /** Module–grade relation IDs from the grade API (`grade[].module_grade_id`). */
  module_grade_id: number[];
  /** Used to refresh school modules list after success */
  schoolId: string;
};

export type DeleteSchoolModuleGradePayload = {
  school_id: number;
  /** School-module list row ids from GET `/api/school_module/` (each item’s top-level `id`, not `module.id`). */
  school_module_grade: number[];
  schoolId: string;
};

export const createSchoolModuleGrade = createAction<CreateSchoolModuleGradePayload>(
  CREATE_SCHOOL_MODULE_GRADE,
);

export const deleteSchoolModuleGrade = createAction<DeleteSchoolModuleGradePayload>(
  DELETE_SCHOOL_MODULE_GRADE,
);

export const deleteSchool = createAction<DeleteSchoolPayload>(DELETE_SCHOOL);

export interface schoolListSuccessPayload {
  id?: number | string;
  name: string;
  en_name?: string;
  birth_date?: string;
  organization_name?: string;
  member_of?: string;
  principal_name?: string;
  schools_address: string;
  postal_code?: string;
  schools_phone: string;
  schools_tele?: string;
  schools_hot_line?: string;
  schools_fax?: string;
  schools_email?: string;
  schools_bank_account_number: string;
  schools_bank_account_name: string;
  status: 1 | 2;
  created_date: string;
  updated_date: string;
  schools_type: string;
  wards?: any;
  schools_bank_id?: string | number;
  wards_code?: string,
  wards_code_2?:string
}

export type schoolModuleProps = {
  id: number;
  name: string;
  en_name: string;
  short_name: string;
  description: string;
  type: string | null;
  syllabus: string;
  exam_duration: number;
  exam_pass_score: number;
  practice_duration: number;
  practice_pass_score: number;
  grades: number[];
  status: 0 | 1;
};

type schoolDataDetailType = Omit<
  schoolListSuccessPayload,
  'id' | 'status' | 'created_date' | 'updated_date' | 'wards'
>;

type listSchoolModuleProps = {
  pageSize?: number, 
  page?: number, 
  status?: 0 | 1, 
  schoolId?: number
}

export type fetchListSchoolModuletype = {
  id: number;
  status: number;
  created_date: string;
  updated_date: string;
  module: number;
};
export type schoolYearDataType = {
  name: string;       
  year: number;       
  start_date: string; 
  end_date: string;   
};
export type FetchUpgradeClassParams = {
  page?: number;
  page_size?: number;
  year?:number
};
export const fetchingSchoolList = createAction(FETCHING_SCHOOL_LIST, (filters: any) => ({
  payload: filters,
}));
export const fetchingSchoolListSuccess = createAction<
  schoolListSuccessPayload[]
>(FETCHING_SCHOOL_LIST_SUCCESS);
export const fetchingSchoolListFailure = createAction(
  FETCHING_SCHOOL_LIST_FAILURE,
);
export const createSchool = createAction<schoolDataDetailType>(CREATE_SCHOOL);

export const getSchoolDetail = createAction(
  GET_SCHOOL_DETAIL,
  (id: string) => ({
    payload: { id: id },
  }),
);
export const clearSchool = createAction(CLEAR_SCHOOL);

export const updateSchool = createAction<any>(
  UPDATE_SCHOOL,
  (data: schoolDataDetailType, id: string) => ({
    payload: { data: data, id: id },
  }),
);
export const fetchListSchoolModules = createAction<any>(
  FETCH_SCHOOL_MODULES,
  ({page, pageSize, schoolId }:{page: number, pageSize: number, schoolId: number}) => ({
    payload: {
      page: page,
      pageSize: pageSize,
      schoolId: schoolId,
    },
  }),
);
export type FetchSchoolYearListParams = {
  order_by: string;
  page: number;
  page_size: number;
};
export const fetchProviceList = createAction(FETCHING_PROVINCE_LIST);
export const fetchDistrictList = createAction(FETCHING_DISTRICT_LIST, (provinceId: string) => ({
 payload: { provinceId: provinceId }
}));
export const fetchWardList = createAction(FETCHING_WARD_LIST, (districtId: string) => ({
 payload: { districtId: districtId }
}));
export const fetchBankSupportList = createAction(FETCHING_BANK_SUPPORT_LIST);
export const fetchSchoolModuleList = createAction(FETCH_SCHOOL_MODULES_LIST, (schoolId: string) => ({
  payload: {
    schoolId: schoolId
  }})
)
export const addSchoolModule = createAction(ADD_SCHOOL_MODULE, (moduleIds: string | string[], schoolId: string) => ({
  payload: {
    moduleIds,
    schoolId
  }
}))

export const removeSchoolModule = createAction(REMOVE_SCHOOL_MODULE, (moduleIds: string | string[], schoolId: string) => ({
  payload: {
    moduleIds,
    schoolId
  }
}))

export const fetchPersonnelListRequest = (schoolId: string, name?: string, enrollment?: boolean, enroll_status?: string, course_id?: string, page?:number,page_size?:number) => ({
  type: FETCH_PERSONNEL_LIST_REQUEST,
  payload: { schoolId, name, enrollment, enroll_status, course_id,page,page_size }
});

export const fetchPersonnelListSuccess = (data: any) => ({
  type: FETCH_PERSONNEL_LIST_SUCCESS,
  payload: { data }
});

export const fetchPersonnelListFailure = (error: any) => ({
  type: FETCH_PERSONNEL_LIST_FAILURE,
  payload: { error }
});

export const fetchSchoolYearsList = (schoolId: string, params:FetchSchoolYearListParams) => ({
  type: FETCH_SCHOOL_YEARS_LIST,
  payload: { schoolId,params }
});
export const createSchoolYear = (schoolId:string, data: schoolYearDataType,autoCreateSchoolYear:boolean,) => ({
  type: CREATE_SCHOOL_YEAR,
  payload: { schoolId, data,autoCreateSchoolYear }
});

export const updateSchoolYear = (schoolId:string,id:string, data: schoolYearDataType) => ({
  type: UPDATE_SCHOOL_YEAR,
  payload: {schoolId, data,id }
});

export const assignSchoolYear = (schoolId:string,id:string) => ({
  type: ASSIGN_SCHOOL_YEAR,
  payload: {schoolId, id }
});

export const fetchPreviewUpgradeClass = (schoolId: string) => ({
  type: FETCH_PREVIEW_UPGRADE_CLASS,
  payload: { schoolId }
});
export const fetchUpgradeClassLogs = (schoolId: string,params:FetchUpgradeClassParams) => ({
  type: FETCH_UPGRADE_CLASS_LOGS,
  payload: { schoolId,params }
});

export const confirmUpgradeClass = (schoolId: string) => ({
  type: CONFIRM_UPGRADE_CLASS,
  payload: { schoolId }
});

export const downloadTemplateAccountSchoolList = createAction(DOWNLOAD_TEMPLATE_ACCOUNT_SCHOOL_LIST, (schoolId: number) => ({
  payload: {
      schoolId: schoolId
  }
}));

export const clearTemplateSchoolFile = createAction('CLEAR_TEMPLATE_SCHOOL_FILE');